// extracted by mini-css-extract-plugin
export var collapsedSummary = "_m0-0";